// api/turmericApi.js
import axios from 'axios';

const CORIANDER_API_BASE = "https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing";
const BASE_URL = 'https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing';
const TURMERIC_API_BASE = "https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/turmeric_summary";
const RTC_API_BASE = "https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/RTC_Summary";

// Helper function to format date for API
// const formatDateForAPI = (date) => {
//     if (!date) return "";
//     const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

//     const year = localDate.getFullYear();
//     const month = String(localDate.getMonth() + 1).padStart(2, '0');
//     const day = String(localDate.getDate()).padStart(2, '0');

//     return `${year}-${month}-${day}`;
// };

const formatDateForAPI = (date) => {
    if (!date) return "";

    // Method 1: Simple approach - use local date directly
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};


export const fetchCorianderHistoryData = async (
    page = 1,
    startDate = null,
    endDate = null,
    rowsPerPageValue = null
) => {
    try {
        const start = startDate
            ? formatDateForAPI(startDate)
            : formatDateForAPI(new Date());
        const end = endDate
            ? formatDateForAPI(endDate)
            : formatDateForAPI(new Date());
        const noOfRecords = rowsPerPageValue || 10; // Default rows per page

        const endpoint = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/coriander_history?start_date=${start}&end_date=${end}&page_no=${page}&no_of_records=${noOfRecords}`;

        console.log(`Fetching Coriander data from ${start} to ${end}, Page: ${page}, Records: ${noOfRecords}`);

        const response = await axios.get(endpoint);
        // console.log("Coriander API response:", response);

        // Check if the response has the expected structure
        if (
            response.data &&
            response.data.statusCode === 200 &&
            response.data.body &&
            response.data.body.success
        ) {
            const successData = response.data.body.success;

            // console.log("Success Coriander data:", successData);

            // Process and return the data
            const processedData = {
                data: successData.data || [],
                pagination: {
                    currentPage: successData.page_no || 1,
                    totalPages: successData.total_pages || 1,
                    totalRecords: successData.total_records || 0,
                    rowsPerPage: rowsPerPageValue || noOfRecords,
                },
                metrics: {
                    totalSackCount: successData.total_sack_count || 0,
                    totalThreadCount: successData.total_thread_count || 0,
                    lastThreadTimestamp: successData.last_thread_timestamp,
                }
            };

            return {
                success: true,
                data: processedData
            };

        } else {
            throw new Error("Unexpected Coriander API response format");
        }
    } catch (err) {
        console.error("Error fetching Coriander data:", err);
        return {
            success: false,
            error: err.message || "Failed to fetch Coriander data"
        };
    }
};

export const fetchTurmericData = async (startDate, endDate) => {
    // console.log("start date, end Date ==", startDate, endDate);
    try {
        const start = startDate
            ? formatDateForAPI(startDate)
            : formatDateForAPI(new Date());
        const end = endDate
            ? formatDateForAPI(endDate)
            : formatDateForAPI(new Date());
        console.log("start date, end Date ==", start, end);

        // const endpoint = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/turmeric_summary?start_date=${start}&end_date=${end}`;
        const endpoint = `${TURMERIC_API_BASE}?start_date=${start}&end_date=${end}`;

        console.log(`Fetching turmeric metrics data from ${start} to ${end}`);

        const response = await axios.get(endpoint);
        // console.log("Turmeric Metrics API response:", response);

        // Check if the response has the expected structure
        if (
            response.data &&
            response.data.statusCode === 200 &&
            response.data.body &&
            response.data.body.success
        ) {
            const metricsData = response.data.body.success;
            // console.log("Success turmeric metrics data:", metricsData);

            // Extract hopper1 and hopper2 data
            const hopper1Data = metricsData.hopper1 || {};
            const hopper2Data = metricsData.hopper2 || {};

            // Process and format unsafe events if available
            const hopper1UnsafeEvents = (hopper1Data.unsafe_event || []).slice(-10).reverse();
            const hopper2UnsafeEvents = (hopper2Data.unsafe_event || []).slice(-10).reverse();

            // Return processed data instead of directly updating state
            return {
                success: true,
                data: {
                    hopper1: {
                        sackCount: hopper1Data.total_sack_count?.toString() || "0",
                        magneticGrillCleaning: hopper1Data.last_grill_cleaning_time || "No detection",
                        magneticGrillCleaning_image: hopper1Data.last_grill_cleaning_image || null,
                        // Handle magnetic grill presence based on lid presence
                        // magneticGrillPresence: hopper1Data.last_grill_presence === "present",
                        magneticGrillPresence: hopper1Data.last_grill_presence,
                        // Handle safety mesh presence based on lid presence  
                        // safetyMeshPresence: hopper1Data.last_safety_mesh_presence === "present",
                        safetyMeshPresence: hopper1Data.last_safety_mesh_presence,
                        // Handle lid presence - convert "present"/"absent" to boolean/null
                        lidPresence: hopper1Data.last_lid_presence === "present" ? true :
                            hopper1Data.last_lid_presence === "absent" ? null : null,
                        cleaning_history: hopper1Data.cleaning_history || [],
                        last_safety_mesh_presence_timestamp: hopper1Data?.last_safety_mesh_presence_timestamp,
                        last_safety_mesh_presence_image: hopper1Data?.last_safety_mesh_presence_image,
                        last_magnetic_grill_presence_timestamp: hopper1Data?.last_magnetic_grill_presence_timestamp,
                        last_magnetic_grill_presence_image: hopper1Data?.last_magnetic_grill_presence_image,
                    },
                    hopper2: {
                        sackCount: hopper2Data.total_sack_count?.toString() || "0",
                        magneticGrillCleaning: hopper2Data.last_grill_cleaning_time || "No detection",
                        magneticGrillCleaning_image: hopper2Data.last_grill_cleaning_image || null,
                        // Handle magnetic grill presence based on lid presence
                        // magneticGrillPresence: hopper2Data.last_grill_presence === "present",
                        magneticGrillPresence: hopper2Data.last_grill_presence,
                        // Handle safety mesh presence based on lid presence
                        // safetyMeshPresence: hopper2Data.last_safety_mesh_presence === "present",
                        safetyMeshPresence: hopper2Data.last_safety_mesh_presence,
                        // Handle lid presence - convert "present"/"absent" to boolean/null
                        lidPresence: hopper2Data.last_lid_presence === "present" ? true :
                            hopper2Data.last_lid_presence === "absent" ? null : null,
                        cleaning_history: hopper2Data.cleaning_history || [],
                        last_safety_mesh_presence_timestamp: hopper2Data?.last_safety_mesh_presence_timestamp,
                        last_safety_mesh_presence_image: hopper2Data?.last_safety_mesh_presence_image,
                        last_magnetic_grill_presence_timestamp: hopper2Data?.last_magnetic_grill_presence_timestamp,
                        last_magnetic_grill_presence_image: hopper2Data?.last_magnetic_grill_presence_image,
                    },
                    unsafeEvents: {
                        hopper1: hopper1UnsafeEvents,
                        hopper2: hopper2UnsafeEvents
                    }
                }
            };

        } else {
            throw new Error("Unexpected turmeric metrics API response format");
        }
    } catch (err) {
        console.error("Error fetching turmeric metrics data:", err);
        return {
            success: false,
            error: err.message || "Failed to fetch turmeric metrics data"
        };
    }
};

export const fetchRTCData = async (startDate = null, endDate = null) => {
    try {
        // Format dates for API request
        const today = new Date();
        const formattedStartDate = startDate ? formatDateForAPI(startDate) : formatDateForAPI(today);
        const formattedEndDate = endDate ? formatDateForAPI(endDate) : formatDateForAPI(today);

        console.log(`Fetching RTC data from ${formattedStartDate} to ${formattedEndDate}`);

        // Make API request
        // const response = await axios.get(
        //     `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/RTC_Summary?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        // );
        const response = await axios.get(
            `${RTC_API_BASE}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
        );

        // console.log("RTC API response:", response);

        if (response.data && response.data.body && response.data.body.success) {
            const apiData = response.data.body.success;

            // Create a normalized version of the API data to match the expected structure
            const normalizedData = {
                primix1: apiData.primix1 || { unsafe_event: [], cleaning_history: [] },
                primix2: apiData.primix2 || { unsafe_event: [], cleaning_history: [] },
                finalmixer1: apiData.final_mixture1 || { unsafe_event: [], cleaning_history: [] }, // Map final_mixture1 to finalmixer1
                finalmixer2: apiData.final_mixture2 || { unsafe_event: [], cleaning_history: [] }, // Map final_mixture2 to finalmixer2
                grinder1: apiData.grinder1 || { sack_count: 0, bucket_count: 0 },
                grinder2: apiData.grinder2 || { sack_count: 0, bucket_count: 0 }
            };

            // Process RTC data
            const rtcData = {
                premixer1: {
                    magneticRodCleaning: normalizedData.primix1?.last_magnetic_plate_cleaning_time || "---",
                    // safetyMeshLifted: normalizedData.primix1?.safety_mesh_lifted_status === "present",
                    safetyMeshLifted: normalizedData.primix1?.safety_mesh_lifted_status,
                    lid_presence: normalizedData.primix1?.lid_presence === "present" ? true : null,
                    last_primix1_safety_mesh_presence_timestamp: normalizedData.primix1?.safety_mesh_lifted_timestamp,
                    last_primix1_safety_mesh_presence_image: normalizedData.primix1?.safety_mesh_lifted_image,
                },
                premixer2: {
                    magneticRodCleaning: normalizedData.primix2?.last_magnetic_plate_cleaning_time || "---",
                    // safetyMeshLifted: normalizedData.primix2?.safety_mesh_lifted_status === "present",
                    safetyMeshLifted: normalizedData.primix2?.safety_mesh_lifted_status,
                    lid_presence: normalizedData.primix2?.lid_presence === "present" ? true : null,
                    last_primix2_safety_mesh_presence_timestamp: normalizedData.primix2?.safety_mesh_lifted_timestamp,
                    last_primix2_safety_mesh_presence_image: normalizedData.primix2?.safety_mesh_lifted_image,
                },
                finalmixer1: {
                    magneticRodCleaning: normalizedData.finalmixer1?.last_magnetic_plate_cleaning_time || "---",
                    // safetyMeshLifted: normalizedData.finalmixer1?.safety_mesh_lifted_status === "present",
                    safetyMeshLifted: normalizedData.finalmixer1?.safety_mesh_lifted_status,
                    lid_presence: normalizedData.finalmixer1?.lid_presence === "present" ? true : null,
                    last_finalmixer1_safety_mesh_presence_timestamp: normalizedData.finalmixer1?.safety_mesh_lifted_timestamp,
                    last_finalmixer1_safety_mesh_presence_image: normalizedData.finalmixer1?.safety_mesh_lifted_image,
                },
                finalmixer2: {
                    magneticRodCleaning: normalizedData.finalmixer2?.last_magnetic_plate_cleaning_time || "---",
                    // safetyMeshLifted: normalizedData.finalmixer2?.safety_mesh_lifted_status === "present",
                    safetyMeshLifted: normalizedData.finalmixer2?.safety_mesh_lifted_status,
                    lid_presence: normalizedData.finalmixer2?.lid_presence === "present" ? true : null,
                    last_finalmixer2_safety_mesh_presence_timestamp: normalizedData.finalmixer2?.safety_mesh_lifted_timestamp,
                    last_finalmixer2_safety_mesh_presence_image: normalizedData.finalmixer2?.safety_mesh_lifted_image,
                },
                grinder1: {
                    sackCount: normalizedData.grinder1?.sack_count || 0,
                    bucketCount: normalizedData.grinder1?.bucket_count || 0,
                },
                grinder2: {
                    sackCount: normalizedData.grinder2?.sack_count || 0,
                    bucketCount: normalizedData.grinder2?.bucket_count || 0,
                }
            };

            // Process unsafe events
            const unsafeEvents = {
                premixer1: (normalizedData.primix1?.unsafe_event || []).slice(-10).reverse(),
                premixer2: (normalizedData.primix2?.unsafe_event || []).slice(-10).reverse(),
                finalmixer1: (normalizedData.finalmixer1?.unsafe_event || []).slice(-10).reverse(),
                finalmixer2: (normalizedData.finalmixer2?.unsafe_event || []).slice(-10).reverse(),
            };

            const cleaningHistory = {
                premixer1: normalizedData.primix1?.cleaning_history || [],
                premixer2: normalizedData.primix2?.cleaning_history || [],
                finalmixer1: normalizedData.finalmixer1?.cleaning_history || [],
                finalmixer2: normalizedData.finalmixer2?.cleaning_history || [],
            };

            // console.log("Processed RTC data:", rtcData);
            // console.log("Processed unsafe events:", unsafeEvents);
            // console.log("Processed cleaning history:", cleaningHistory);

            return {
                success: true,
                data: {
                    cardData: normalizedData,
                    rtcData: rtcData,
                    unsafeEvents: unsafeEvents,
                    cleaningHistory: cleaningHistory,
                }
            };

        } else {
            throw new Error("Invalid response format from RTC API");
        }
    } catch (err) {
        console.error("Error fetching RTC data:", err);
        return {
            success: false,
            error: err.message || "Failed to fetch RTC data"
        };
    }
};

export const fetchPackagingData = async (startDate, endDate, page = 1, rowsPerPage = 10) => {
    try {
        const formattedStartDate = startDate.toISOString().split('T')[0];
        const formattedEndDate = endDate.toISOString().split('T')[0];

        const apiUrl = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/packaging_history?start_date=${formattedStartDate}&end_date=${formattedEndDate}&no_of_records=${rowsPerPage}&page_no=${page}`;

        const response = await axios.get(apiUrl);

        if (response.data && response.data.body && response.data.body.success) {
            const { summary } = response.data.body.success;

            return {
                success: true,
                data: {
                    metalDetectorCalibration: summary.last_metal_calibration_time || "---",
                    coinMetalDetectorCalibration: summary.last_coin_metal_calibration_time || "---",
                    packetCount: summary.total_packet_count || 0,
                    tapeAlignmentCount: summary.total_tape_missalignment || 0,
                    coin_metal_calibration_history: response.data.body.success.coin_metal_calibration_history || [],
                    metal_calibration_history: response.data.body.success.metal_calibration_history || [],
                    tape_missalignment_history: response?.data.body.success.tape_missalignment_history || []
                }
            };
        } else {
            return {
                success: false,
                error: "Invalid response structure"
            };
        }
    } catch (error) {
        console.error("Error fetching packaging data:", error);
        return {
            success: false,
            error: error.message
        };
    }
};

// for individual pages API's

export const fetchCorianderDetailedData = async (
    page = 1,
    startDate = null,
    endDate = null,
    rowsPerPageValue = null,
    currentPagination = { rowsPerPage: 10 }
) => {
    try {
        const start = startDate
            ? formatDateForAPI(startDate)
            : formatDateForAPI(new Date());
        const end = endDate
            ? formatDateForAPI(endDate)
            : formatDateForAPI(new Date());

        const noOfRecords = rowsPerPageValue || currentPagination.rowsPerPage;

        const endpoint = `https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/coriander_history?start_date=${start}&end_date=${end}&page_no=${page}&no_of_records=${noOfRecords}`;

        console.log(`Fetching Detailed Coriander data from ${start} to ${end}, Page: ${page}, Records: ${noOfRecords}`);

        const response = await axios.get(endpoint);
        // console.log("Detailed Coriander API response:", response);

        // Check if the response has the expected structure
        if (
            response.data &&
            response.data.statusCode === 200 &&
            response.data.body &&
            response.data.body.success
        ) {
            const successData = response.data.body.success;
            console.log("success data -->>", successData);

            // Process data to separate date and time
            const processedData = (successData.data || []).map((item) => {
                // Assuming timestamp_range is in format "DD-MM-YY HH:MM AM/PM to DD-MM-YY HH:MM AM/PM"
                const parts = item.timestamp_range.split(" ");

                // Extract date (DD-MM-YY) and convert to DD-MM-YYYY format
                const dateStr = parts[0]; // Format: DD-MM-YY
                const dateParts = dateStr.split("-");
                if (dateParts.length === 3) {
                    // Convert 2-digit year to 4-digit year
                    let year = dateParts[2];
                    if (year.length === 2) {
                        // Assuming 20xx for years (can be adjusted based on requirements)
                        year = "20" + year;
                    }
                    // Format as DD-MM-YYYY
                    dateParts[2] = year;
                    const formattedDate = dateParts.join("-");

                    const time = `${parts[1]} ${parts[2]} - ${parts[5]} ${parts[6]}`; // Extract time (HH:MM AM/PM - HH:MM AM/PM)

                    // Determine shift based on time
                    const timeStr = parts[1] + " " + parts[2];
                    let hour = parseInt(timeStr.split(":")[0]);
                    const isPM = timeStr.includes("PM");

                    if (isPM && hour !== 12) hour += 12;
                    if (!isPM && hour === 12) hour = 0;

                    // Shift I: 6 AM to 6 PM, Shift II: 6 PM to 6 AM
                    const shift = hour >= 6 && hour < 18 ? "I" : "II";

                    return {
                        ...item,
                        date: formattedDate,
                        time,
                        shift,
                    };
                } else {
                    // Fallback if date format is unexpected
                    return {
                        ...item,
                        date: dateStr,
                        time: `${parts[1]} ${parts[2]} - ${parts[5]} ${parts[6]}`,
                        shift: "I", // Default to Shift I if we can't determine
                    };
                }
            });

            console.log("API data received:", processedData);

            // Return processed data with separate API and display metrics
            const result = {
                processedData: processedData,
                originalData: processedData, // Store original data for filtering
                pagination: {
                    currentPage: successData.page_no || 1,
                    totalPages: successData.total_pages || 1,
                    totalRecords: successData.total_records || 0,
                    rowsPerPage: rowsPerPageValue || currentPagination.rowsPerPage,
                },
                apiMetrics: {
                    totalSackCount: successData.total_sack_count || 0,
                    totalThreadCount: successData.total_thread_count || 0,
                    lastThreadTimestamp: successData.last_thread_timestamp,
                },
                displayMetrics: {
                    totalSackCount: successData.total_sack_count || 0,
                    totalThreadCount: successData.total_thread_count || 0,
                    lastThreadTimestamp: successData.last_thread_timestamp,
                }
            };

            return {
                success: true,
                data: result
            };

        } else {
            throw new Error("Unexpected API response format");
        }
    } catch (err) {
        console.error("Error fetching detailed Coriander data:", err);
        return {
            success: false,
            error: err.message || "Failed to fetch detailed Coriander data"
        };
    }
};

// History API turmeric
export const fetchTurmericHistory = async (params) => {
    const {
        page = 1,
        startDate = null,
        endDate = null,
        noOfRecords = 10,
        hopper = 'hopper1'
    } = params;

    try {
        const start = startDate ? formatDateForAPI(startDate) : formatDateForAPI(new Date());
        const end = endDate ? formatDateForAPI(endDate) : formatDateForAPI(new Date());

        const endpoint = `${BASE_URL}/turmeric_history`;

        const response = await axios.get(endpoint, {
            params: {
                start_date: start,
                end_date: end,
                page_no: page,
                no_of_records: noOfRecords,
                hopper: hopper
            }
        });

        console.log("History API response:", response);
        return response.data;
    } catch (error) {
        console.error("Error in fetchTurmericHistory:", error);
        throw error;
    }
};

// Summary API turmeric
export const fetchTurmericSummary = async (startDate, endDate) => {
    try {
        const start = startDate ? formatDateForAPI(startDate) : formatDateForAPI(new Date());
        const end = endDate ? formatDateForAPI(endDate) : formatDateForAPI(new Date());

        const endpoint = `${BASE_URL}/turmeric_summary`;

        const response = await axios.get(endpoint, {
            params: {
                start_date: start,
                end_date: end
            }
        });

        console.log("Summary API response:", response);
        return response.data;
    } catch (error) {
        console.error("Error in fetchTurmericSummary:", error);
        throw error;
    }
};

// Combined export object
const turmericApi = {
    fetchHistory: fetchTurmericHistory,
    fetchSummary: fetchTurmericSummary
};

// export default turmericApi;

export const fetchRTCSummary = async (startDate = null, endDate = null) => {
    try {
        const today = new Date();
        const formattedStartDate = startDate ? formatDateForAPI(startDate) : formatDateForAPI(today);
        const formattedEndDate = endDate ? formatDateForAPI(endDate) : formatDateForAPI(today);

        const endpoint = `${BASE_URL}/RTC_Summary`;

        const response = await axios.get(endpoint, {
            params: {
                start_date: formattedStartDate,
                end_date: formattedEndDate
            }
        });

        console.log("RTC Summary API response:", response);
        return response.data;
    } catch (error) {
        console.error("Error in fetchRTCSummary:", error);
        throw error;
    }
};

// RTC History API
export const fetchRTCHistory = async (params) => {
    const {
        page = 1,
        rowsPerPage = 10,
        startDate = null,
        endDate = null,
        equipment = ''
    } = params;

    try {
        const today = new Date();
        const formattedStartDate = startDate ? formatDateForAPI(startDate) : formatDateForAPI(today);
        const formattedEndDate = endDate ? formatDateForAPI(endDate) : formatDateForAPI(today);

        const endpoint = `${BASE_URL}/RTC_history`;

        const response = await axios.get(endpoint, {
            params: {
                start_date: formattedStartDate,
                end_date: formattedEndDate,
                equipment: equipment,
                no_of_records: rowsPerPage,
                page_no: page
            }
        });

        console.log("RTC History API response:", response);
        return response.data;
    } catch (error) {
        console.error("Error in fetchRTCHistory:", error);
        throw error;
    }
};

// Combined export object
const rtcApi = {
    fetchSummary: fetchRTCSummary,
    fetchHistory: fetchRTCHistory
};

export default { rtcApi, turmericApi };

// File: src/components/API/WebSocketService.js
export const createWebSocketConnection = ({
    setSackCount,
    setTurmericData,
    setHasWebSocketData,
    setUnsafeEvents,
    setRtcData,
    setHasRtcWebSocketData,
    setRtcUnsafeEvents,
    formatIfTimestamp,
    // Add new packaging state setters
    setPackagingData,
    setHasPackagingWebSocketData
}) => {
    const ws = new WebSocket(
        "wss://e6azoov12l.execute-api.ap-south-1.amazonaws.com/testing/"
    );

    ws.onopen = () => {
        console.log("✅ WebSocket connected");
    };

    ws.onmessage = (event) => {
        try {
            const message = JSON.parse(event.data);
            console.log("WS Message: ", message);

            // Handle Coriander data
            if (
                message?.type === "new_data" &&
                message?.key === "coriander#sack#count"
            ) {
                setSackCount(message.count_for_date);
            }

            // Handle packaging data - ADD THIS SECTION
            if (
                message?.type === "new_data" &&
                message?.key &&
                message.key.startsWith("packaging#")
            ) {
                // Mark that we have WebSocket data for packaging
                setHasPackagingWebSocketData(true);

                setPackagingData((prevData) => {
                    const newData = { ...prevData };

                    // Handle metal detector calibration
                    if (message.key === "packaging#metal_detector#calibration") {
                        newData.metalDetectorCalibration = formatIfTimestamp(message.timestamp);
                    }
                    // Handle coin metal detector calibration
                    else if (message.key === "packaging#coin_metal_detector#calibration") {
                        newData.coinMetalDetectorCalibration = formatIfTimestamp(message.timestamp);
                        newData.coinMetalDetectorType = "coin";
                    }
                    else if (message.key === "packaging#stick_metal_detector#calibration") {
                        // Replace coin metal detector data with stick metal detector data
                        newData.coinMetalDetectorCalibration = formatIfTimestamp(message.timestamp);
                        newData.coinMetalDetectorType = "stick";
                    }
                    // Handle tape alignment
                    else if (message.key === "packaging#tape#alignment") {
                        newData.tapeAlignmentCount = message.count_for_date || 0;
                    }
                    // Handle packet count
                    else if (message.key === "packaging#packet#count") {
                        newData.packetCount = message.count_for_date || 0;
                    }

                    return newData;
                });
            }

            // Handle turmeric data
            if (
                message?.type === "new_data" &&
                message?.key &&
                message.key.startsWith("turmeric#")
            ) {
                const keyParts = message.key.split("#");
                const hopperType = keyParts[1]; // hopper1 or hopper2
                const metricType = keyParts[2]; // grill, mesh, lid, sack
                const metricProperty = keyParts[3]; // presence, cleaning, count

                if (hopperType && metricType) {
                    setHasWebSocketData(prev => ({
                        ...prev,
                        [hopperType]: true
                    }));

                    setTurmericData((prevData) => {
                        const newData = { ...prevData };

                        // Handle different metric types
                        if (metricType === "grill" && metricProperty === "presence") {
                            // Handle magnetic grill presence
                            newData[hopperType].magneticGrillPresence = message.data.status === "present";
                        }
                        else if (metricType === "mesh" && metricProperty === "presence") {
                            // Handle safety mesh presence
                            newData[hopperType].safetyMeshPresence = message.data.status === "present";
                        }
                        else if (metricType === "lid" && metricProperty === "presence") {
                            // Handle lid presence - this will override magnetic grill and safety mesh display
                            if (message.data.status === "present") {
                                newData[hopperType].lidPresence = true;
                            } else if (message.data.status === "absent") {
                                // If lid is absent, reset to show individual values
                                newData[hopperType].lidPresence = null;
                            }
                        }
                        else if (metricType === "grill" && metricProperty === "cleaning") {
                            // Handle magnetic grill cleaning time
                            newData[hopperType].magneticGrillCleaning = formatIfTimestamp(message.timestamp);
                        }
                        else if (metricType === "sack" && metricProperty === "count") {
                            // Handle sack count
                            newData[hopperType].sackCount = message.count_for_date || 0;
                        }

                        return newData;
                    });
                }
            }

            if (
                message?.type === "new_data" &&
                message?.key &&
                (message.key === "turmeric#hopper1#unsafe_event" ||
                    message.key === "turmeric#hopper2#unsafe_event")
            ) {
                const hopperType = message.key.includes("hopper1")
                    ? "hopper1"
                    : "hopper2";

                // Mark that we have WebSocket data for this hopper
                setHasWebSocketData(prev => ({
                    ...prev,
                    [hopperType]: true
                }));

                setUnsafeEvents((prev) => {
                    const newEvents = { ...prev };
                    // Add new event to the beginning of the array
                    newEvents[hopperType] = [
                        message.data,
                        ...newEvents[hopperType],
                    ].slice(0, 10); // Keep only the last 10 events
                    return newEvents;
                });
            }

            // Handle RTC data (existing code remains same)
            if (
                message?.type === "new_data" &&
                message?.key &&
                message.key.startsWith("rtc#")
            ) {
                const keyParts = message.key.split("#");
                const mixerType = keyParts[1]; // premixer1, premixer2, finalmixer1, finalmixer2, grinder1, grinder2
                const metricType = keyParts[2]; // mesh, magnetic, sack, bucket
                const metricProperty = keyParts[3]; // presence, cleaning, count

                if (mixerType && metricType) {
                    // Mark that we have WebSocket data for this mixer
                    setHasRtcWebSocketData(prev => ({
                        ...prev,
                        [mixerType]: true
                    }));

                    setRtcData((prevData) => {
                        const newData = { ...prevData };

                        if (
                            (mixerType === "premixer1" ||
                                mixerType === "premixer2" ||
                                mixerType === "finalmixer1" ||
                                mixerType === "finalmixer2") &&
                            metricType === "mesh" &&
                            metricProperty === "presence"
                        ) {
                            if (!newData[mixerType]) {
                                newData[mixerType] = {};
                            }
                            newData[mixerType].safetyMeshLifted =
                                message.data.status === "present";
                        }
                        else if (
                            (mixerType === "premixer1" ||
                                mixerType === "premixer2" ||
                                mixerType === "finalmixer1" ||
                                mixerType === "finalmixer2") &&
                            metricType === "magnetic" &&
                            metricProperty === "cleaning"
                        ) {
                            if (!newData[mixerType]) {
                                newData[mixerType] = {};
                            }
                            newData[mixerType].magneticRodCleaning = formatIfTimestamp(
                                message.timestamp
                            );
                        }
                        else if (mixerType === "grinder1" || mixerType === "grinder2") {
                            if (!newData[mixerType]) {
                                newData[mixerType] = {};
                            }

                            if (metricType === "sack" && metricProperty === "count") {
                                newData[mixerType].sackCount = message.count_for_date || 0;
                            } else if (
                                metricType === "bucket" &&
                                metricProperty === "count"
                            ) {
                                newData[mixerType].bucketCount = message.count_for_date || 0;
                            }
                            else if (
                                (mixerType === "premixer1" ||
                                    mixerType === "premixer2" ||
                                    mixerType === "finalmixer1" ||
                                    mixerType === "finalmixer2") &&
                                metricType === "lid" &&
                                metricProperty === "presence"
                            ) {
                                if (!newData[mixerType]) {
                                    newData[mixerType] = {};
                                }
                                newData[mixerType].lid_presence = message.data.status === "present";
                            }
                        }
                        return newData;
                    });
                }
            }

            // rtc unsafe events (existing code remains same)
            if (
                message?.type === "new_data" &&
                message?.key &&
                (message.key === "rtc#premixer1#unsafe_event" ||
                    message.key === "rtc#premixer2#unsafe_event" ||
                    message.key === "rtc#finalmixer1#unsafe_event" ||
                    message.key === "rtc#finalmixer2#unsafe_event")
            ) {
                const rtcComponent = message.key.split("#")[1];

                // Mark that we have WebSocket data for this component
                setHasRtcWebSocketData(prev => ({
                    ...prev,
                    [rtcComponent]: true
                }));

                setRtcUnsafeEvents((prev) => {
                    const newEvents = { ...prev };
                    newEvents[rtcComponent] = [
                        message.data,
                        ...newEvents[rtcComponent],
                    ].slice(0, 10);
                    return newEvents;
                });
            }
        } catch (e) {
            console.error("❌ Error parsing message:", e);
        }
    };

    ws.onerror = (error) => {
        console.error("❌ WebSocket error:", error);
    };

    ws.onclose = (event) => {
        console.log("🔌 WebSocket disconnected", event);
    };

    return ws;
};

export const downloadCleaningActivityExcelTurmeric = async ({ startDate, endDate, section }) => {
    try {
        const baseUrl = 'https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/export_ccp_activity';

        // Build URL with query parameters
        const params = new URLSearchParams({
            start_date: startDate,
            end_date: endDate,
            section: section
        });

        const url = `${baseUrl}?${params.toString()}`;

        console.log('Download URL:', url);

        const response = await axios.get(url, {
            responseType: 'blob', // Important for file download
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000, // 30 seconds timeout for large files
        });

        return response;
    } catch (error) {
        console.error('Error in downloadCleaningActivityExcel:', error);
        throw error;
    }
};

export const fetchCleaningActivityDataTurmeric = async ({ startDate, endDate, section }) => {
    try {
        const baseUrl = 'https://g1e3kx0ij7.execute-api.ap-south-1.amazonaws.com/testing/export_ccp_activity';

        // Build URL with query parameters
        const params = new URLSearchParams({
            start_date: startDate,
            end_date: endDate,
            section: section
        });

        const url = `${baseUrl}?${params.toString()}`;

        console.log('Fetching cleaning data from:', url);

        const response = await fetch(url);
        const result = await response.json();

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return result;
    } catch (error) {
        console.error('Error in fetchCleaningActivityData:', error);
        throw error;
    }
};




export const saveActualCount = async (payload) => {
    try {
        const response = await axios.post(`${BASE_URL}/save-actual-count`, payload);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error saving actual count:", error);
        return {
            success: false,
            error: error?.response?.data?.message || error.message || "Failed to save actual count"
        };
    }
};

export const insertManualValidation = async (payload) => {
    try {
        const response = await axios.post(`${BASE_URL}/set-maual-validations`, payload);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error inserting manual validation:", error);
        return {
            success: false,
            error: error?.response?.data?.message || error.message || "Failed to save manual validation"
        };
    }
};

export const fetchLatestManualValidation = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/get-latest-manual-validations`);
        // Expecting API to return the latest item directly in response.data
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching latest manual validation:", error);
        return {
            success: false,
            error: error?.response?.data?.message || error.message || "Failed to fetch manual validation"
        };
    }
};

export const fetchHistoricalManualValidations = async (startDate, endDate) => {
    try {
        const start = startDate ? formatDateForAPI(startDate) : formatDateForAPI(new Date());
        const end = endDate ? formatDateForAPI(endDate) : formatDateForAPI(new Date());
        
        const response = await axios.get(`${BASE_URL}/get-historical-manual-validations`, {
            params: {
                start_date: start,
                end_date: end
            }
        });
        
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Error fetching historical manual validations:", error);
        return {
            success: false,
            error: error?.response?.data?.message || error.message || "Failed to fetch historical manual validations"
        };
    }
};